export default "__VITE_ASSET__97b8f9ed__"